// Centralized version label for the frontend UI.
// Update this single value when bumping the displayed build version.
export const APP_VERSION = "2026.07.07";

export default APP_VERSION;
